import React from 'react';

import { colors, eyeStrokeWidth, eyeHightlightSize } from '../../../constants';

const Eyes = ({ container, inner, coordinates, highlightOpacity }) => {
  const leftContainerArgs = { ...container, ...coordinates.leftContainer };
  const leftIrisArgs = { ...inner, ...coordinates.leftIris };
  const rightContainerArgs = { ...container, ...coordinates.rightContainer };
  const rightIrisArgs = { ...inner, ...coordinates.rightIris };
  const highlightFill = `rgba(255, 255, 255, ${highlightOpacity})`;
  const { dark, light } = colors;

  return (
    <g>
      <ellipse 
        stroke={dark}
        strokeWidth={eyeStrokeWidth}
        fill={light}
        { ...leftContainerArgs }
      />
      <ellipse 
        fill={dark}
        { ...leftIrisArgs }
      />
      <circle 
        fill={highlightFill}
        cx={leftIrisArgs.cx + eyeHightlightSize}
        cy={leftIrisArgs.cy - eyeHightlightSize / 2}
        r={eyeHightlightSize}
      />
      <circle 
        fill={highlightFill}
        cx={leftIrisArgs.cx + eyeHightlightSize * 1.8}
        cy={leftIrisArgs.cy + eyeHightlightSize}
        r={eyeHightlightSize / 3}
      />
      <ellipse 
        stroke={dark}
        strokeWidth={eyeStrokeWidth}
        fill={light}
        { ...rightContainerArgs }
      />
      <ellipse 
        fill={dark}
        { ...rightIrisArgs }
      />
      <circle 
        fill={highlightFill}
        cx={rightIrisArgs.cx + eyeHightlightSize}
        cy={rightIrisArgs.cy - eyeHightlightSize / 2}
        r={eyeHightlightSize}
      />
      <circle 
        fill={highlightFill}
        cx={rightIrisArgs.cx + eyeHightlightSize * 1.8}
        cy={rightIrisArgs.cy + eyeHightlightSize}
        r={eyeHightlightSize / 3}
      />
    </g>
  );
}

export default Eyes;
